export const config = Object.freeze({
	ENV: "production",
	API_ADDR: "https://dairy.azdhia.com/api"
})